import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'corner-right-down', 'IconCornerRightDown', [["path",{"d":"M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4","key":"svg-0"}]]);